module.exports = __webpack_public_path__ + "img/cart.0e6b2824.svg";